<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card p-3">
      <div class="card-body">
        <h2 class="card-title-desc">Add System User</h2>
        <staff-form button_text="Add System User" @staffAction="staffAction"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import StaffForm from "@/components/staff/staff-form";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {routeItems} from "@/router/endpoints";

export default {
  page: {
    title: "Add Staff",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {StaffForm, PageHeader, Layout},
  name: "add-staff",
  data() {
    return {
      title: "Add Staff",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Add Staff",
          active: true
        }
      ],
    }
  },
  methods: {
    ... mapActions({
      addStaff: 'administration/addNewSystemUser'
    }),
    async staffAction(data){
      await this.addStaff(data).then(resp => {
        if(resp.publicId){
          successToast(`New Staff ${resp.firstName} ${resp.lastName} added successfully`)
          this.$router.push(routeItems.single_staff_route+'/'+resp.publicId)
        }

      })
    }
  }
}
</script>

<style scoped>

</style>
